module.exports = __webpack_public_path__ + "static/img/box-open.e05e01e8.png";